import useSeti from '@/hooks/useSeti'
import pclnExperimentation from '@pcln/experimentation'
import { formatPackageSearchHref } from '@pcln/horizon-search-form'
import { Box, Link, Text } from 'pcln-design-system'
import { useEffect } from 'react'
import { trackPackageSearchLinkClick, trackPackageSearchLinkView } from '../ga4'
import type { MakeWatchObject, PackagesFormStateType } from '../types'
import { isHotelPlusCar } from './TripTypes'

type AdvancedSearchLinkProps = Readonly<{
  pageName: 'homepage' | 'landing'
  watchState: MakeWatchObject<PackagesFormStateType>
}>

function AdvancedSearchLinkFlight({ pageName, watchState }: AdvancedSearchLinkProps) {
  const {
    watchTripType,
    watchStartLocation,
    watchEndLocation,
    watchStartDate,
    watchEndDate,
    watchTravelers,
    watchHotelStartDate,
    watchHotelEndDate,
    watchPartialStay,
  } = watchState
  useEffect(() => {
    trackPackageSearchLinkView(pageName, watchTripType)
  }, [pageName, watchTripType])
  return (
    <Box>
      <Link
        href={formatPackageSearchHref(
          pageName,
          watchTripType,
          watchStartLocation,
          watchEndLocation,
          watchStartDate,
          watchEndDate,
          watchTravelers,
          watchHotelStartDate,
          watchHotelEndDate,
          watchPartialStay,
        )}
        target='_blank'
        onClick={() => trackPackageSearchLinkClick(pageName, watchTripType)}
      >
        <Text fontSize='14px' fontWeight='bold'>
          Advanced Search (One-Way Flight, Multi-Hotel)
        </Text>
      </Link>
    </Box>
  )
}

function AdvancedSearchLinkHotelCar({ pageName, watchState }: AdvancedSearchLinkProps) {
  const {
    watchTripType,
    watchStartLocation,
    watchEndLocation,
    watchStartDate,
    watchEndDate,
    watchTravelers,
    watchHotelStartDate,
    watchHotelEndDate,
    watchPartialStay,
  } = watchState
  const advancedSearchHotelCarLinkSeti =
    useSeti({
      experimentCode: 'PKG_HP_ADVANCED_SEARCH_HC',
      shouldFireImpression: false,
    }) === 'VARIANT'
  useEffect(() => {
    pclnExperimentation.fireImpression('PKG_HP_ADVANCED_SEARCH_HC')
  }, [])
  useEffect(() => {
    if (advancedSearchHotelCarLinkSeti) {
      trackPackageSearchLinkView(pageName, watchTripType)
    }
  }, [pageName, watchTripType, advancedSearchHotelCarLinkSeti])
  return (
    advancedSearchHotelCarLinkSeti && (
      <Box>
        <Link
          href={formatPackageSearchHref(
            pageName,
            watchTripType,
            watchStartLocation,
            watchEndLocation,
            watchStartDate,
            watchEndDate,
            watchTravelers,
            watchHotelStartDate,
            watchHotelEndDate,
            watchPartialStay,
          )}
          target='_blank'
          onClick={() => trackPackageSearchLinkClick(pageName, watchTripType)}
        >
          <Text fontSize='14px' fontWeight='bold'>
            Advanced Search (Multi-Hotel, Custom Car Dates)
          </Text>
        </Link>
      </Box>
    )
  )
}

export default function AdvancedSearchLink({ pageName, watchState }: AdvancedSearchLinkProps) {
  const { watchTripType } = watchState
  const showAdvancedSearchLinkHotelCar = isHotelPlusCar(watchTripType)
  return (
    <>
      {watchTripType.includes('FLY') && (
        <AdvancedSearchLinkFlight pageName={pageName} watchState={watchState} />
      )}
      {showAdvancedSearchLinkHotelCar && (
        <AdvancedSearchLinkHotelCar pageName={pageName} watchState={watchState} />
      )}
    </>
  )
}
